export enum OrganizationRelocationStatus {
    QUEUED = 'QUEUED',
    RELOCATING = 'RELOCATING',
    COMPLETE = 'COMPLETE',
    FAILED = 'FAILED',
    PENDING_SOURCE_ACCEPTANCE = 'PENDING_SOURCE_ACCEPTANCE',
    PENDING_TARGET_ACCEPTANCE = 'PENDING_TARGET_ACCEPTANCE',
    ACCEPTED = 'ACCEPTED',
    REJECTED = 'REJECTED'
}